var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_svg__b)",
    d: "m63.889 12.405-38.614-6.11c-1.347-.212-2.608.728-2.817 2.1l-8.385 55.059c-.21 1.373.713 2.658 2.06 2.872l38.613 6.109c1.347.213 2.609-.727 2.818-2.1l8.385-55.058c.209-1.373-.713-2.659-2.06-2.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_svg__c)",
    d: "M55.24 13.969H16.163c-1.364 0-2.469 1.126-2.469 2.515v55.718c0 1.39 1.105 2.515 2.468 2.515H55.24c1.363 0 2.468-1.126 2.468-2.515V16.484c0-1.389-1.105-2.515-2.468-2.515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F65E5E",
    d: "M53.05 64.692c0 3.05-2.424 5.52-5.415 5.52s-5.416-2.47-5.416-5.52 2.424-5.52 5.416-5.52c2.991 0 5.415 2.47 5.415 5.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.176 24.87c0-1.17 0-1.755.237-2.198a2 2 0 0 1 .817-.817c.443-.238 1.029-.238 2.2-.238h26.028c1.17 0 1.756 0 2.199.238a2 2 0 0 1 .817.817c.238.443.238 1.028.238 2.199s0 1.756-.238 2.199a2 2 0 0 1-.817.817c-.443.237-1.028.237-2.199.237H22.429c-1.17 0-1.756 0-2.198-.237a2 2 0 0 1-.818-.817c-.237-.443-.237-1.029-.237-2.2M19.176 36.582c0-1.171 0-1.756.237-2.2a2 2 0 0 1 .817-.816c.443-.238 1.029-.238 2.2-.238h26.028c1.17 0 1.756 0 2.199.238a2 2 0 0 1 .817.817c.238.443.238 1.028.238 2.199s0 1.756-.238 2.199a2 2 0 0 1-.817.817c-.443.237-1.028.237-2.199.237H22.429c-1.17 0-1.756 0-2.198-.237a2 2 0 0 1-.818-.817c-.237-.443-.237-1.029-.237-2.2M19.176 48.3c0-1.17 0-1.756.237-2.198a2 2 0 0 1 .817-.818c.443-.237 1.029-.237 2.2-.237h14.315c1.17 0 1.756 0 2.199.237a2 2 0 0 1 .817.818C40 46.544 40 47.13 40 48.3s0 1.755-.238 2.198a2 2 0 0 1-.817.818c-.443.237-1.028.237-2.199.237H22.43c-1.17 0-1.756 0-2.198-.237a2 2 0 0 1-.818-.818c-.237-.443-.237-1.028-.237-2.199"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_svg__d)",
    d: "M71.048 67.27 59.39 47.453C58.427 45.818 56.743 45 55.059 45l-6.27 14.815 6.27 14.815h11.66c3.848 0 6.254-4.09 4.33-7.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_svg__e)",
    d: "M50.727 47.453 39.068 67.27c-1.924 3.27.481 7.36 4.33 7.36h11.66V45c-1.684 0-3.368.818-4.33 2.453"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.704,
    d: "M55.055 52.406v10.185M55.055 68.14v1.853"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "warning_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-43.85321 59.95294 -53.1341 -38.8655 62.027 10.575)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CA6B7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "warning_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-37.16334 55.0161 -47.46248 -32.06087 54.359 17.923)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD6E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_svg__d",
    x1: 60.257,
    x2: 60.257,
    y1: 42.712,
    y2: 85.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_svg__e",
    x1: 46.724,
    x2: 46.724,
    y1: 42.712,
    y2: 85.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h67.674v68.976H6z"
  })))));
};
export default SvgWarning;